// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3rsob","fileBtn":"File_fileBtn__3bgNT","closeBtn":"File_closeBtn__3kD0y","fileSelected":"File_fileSelected__3Rnxm","disabled":"File_disabled__eIhIb"};